import AreaChart from "../../../../components/areaChart/areaChart";
import { connect } from "react-redux";
export default connect(state => ({
  chartData: state.membershipDraft.membershipDraft.recurringRevenuesYearOverYearComparison,
  width: 1350,
  currencySymbol: state.membershipDraft.membershipDraft.currencySymbol
}))(AreaChart);
